import React, { memo } from 'react';
export var Chevron = /*#__PURE__*/memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#FFA06A' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 2.1 : _ref$strokeWidth,
      _ref$rotationDeg = _ref.rotationDeg,
      rotationDeg = _ref$rotationDeg === void 0 ? 0 : _ref$rotationDeg;
  return /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.5 11.4",
    style: {
      enableBackground: 'new 0 0 22.5 11.4',
      transform: "rotate(".concat(rotationDeg, "deg)")
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: color,
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "21.4,10.4 11.2,1 1,10.4 "
  }));
});